<template>
  <div class="table-responsive table-full-width se-wage-findings-table mt-1 mb-4 ml-0">
    <table class="se-wage-table se-wage-employer-table">
      <thead>
      <tr>
        <th colspan="3">{{sectionTitle}}<template v-if="employerDetails.employerName"> - {{employerDetails.employerName}}</template></th>
      </tr>
      </thead>
      <tbody>
      <tr class="se-wage-subheader-row">
        <td colspan="2">Pay Period Start Date</td>
        <td>{{formatDate(employerDetails.payPeriodStartDate)}}</td>
      </tr>
      <tr class="se-wage-subheader-row">
        <td colspan="2">Pay Period End Date</td>
        <td>{{formatDate(employerDetails.payPeriodEndDate)}}</td>
      </tr>
      <tr class="se-wage-subheader-row">
        <td colspan="2">Pay Date</td>
        <td>{{formatDate(employerDetails.payDate)}}</td>
      </tr>

      <template v-for="categoryDetail in eligibleCategoryTotals" :key="'e-'+categoryDetail.category">
        <tr>
          <td colspan="2">{{categoryLabel(categoryDetail.category)}}</td>
          <td>{{$filters.toCurrency(categoryDetail.amount, true)}}</td>
        </tr>
        <tr v-for="(item, idx) in categoryDetail.incomeItemDetails" :key="'ei-'+idx" class="se-wage-item-row">
          <td>{{item.description}}</td>
          <td>{{$filters.toCurrency(item.payTotalAmount, true)}}</td>
          <td>{{rateDetail(item)}}</td>
        </tr>
      </template>

      <template v-if="ineligibleCategoryTotals.length">
        <tr class="se-wage-subheader-row">
          <td colspan="3">Ineligible Income</td>
        </tr>
        <template v-for="categoryDetail in ineligibleCategoryTotals" :key="'i-'+categoryDetail.category">
          <tr>
            <td colspan="2">{{categoryLabel(categoryDetail.category)}}</td>
            <td>{{$filters.toCurrency(categoryDetail.amount, true)}}</td>
          </tr>
          <tr v-for="(item, idx) in categoryDetail.incomeItemDetails" :key="'ii-'+idx" class="se-wage-item-row">
            <td>{{item.description}}</td>
            <td>{{$filters.toCurrency(item.payTotalAmount, true)}}</td>
            <td>{{rateDetail(item)}}</td>
          </tr>
        </template>
      </template>

      <tr v-if="showW2 && employerDetails.w2MedicareWages">
        <td colspan="2">W-2</td>
        <td>{{$filters.toCurrency(employerDetails.w2MedicareWages, true)}}</td>
      </tr>

      <tr class="se-wage-total-row" v-if="employerDetails.totalWageIncomeAmount !== null && employerDetails.totalWageIncomeAmount !== undefined">
        <td colspan="2">Total</td>
        <td>{{$filters.toCurrency(employerDetails.totalWageIncomeAmount, true)}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import Enums from 'src/model/enums'
import {toMMDDYYYYDateString} from 'src/util/seutil'

export default defineComponent({
  props: {
    sectionTitle: {type: String, required: true},
    employerDetails: {type: Object, required: true},
    showW2: {type: Boolean, default: false}
  },

  computed: {
    eligibleCategoryTotals() {
      return (this.employerDetails.incomeCategoryTotals ?? [])
        .filter(t => t && t.category && !Enums.SeWageIneligibleIncomeCategories.includes(t.category))
        .sort((a, b) => this.categoryOrderIndex(a.category) - this.categoryOrderIndex(b.category))
    },
    ineligibleCategoryTotals() {
      return (this.employerDetails.incomeCategoryTotals ?? [])
        .filter(t => t && t.category && Enums.SeWageIneligibleIncomeCategories.includes(t.category) && Number(t.amount) !== 0)
        .sort((a, b) => this.categoryOrderIndex(a.category) - this.categoryOrderIndex(b.category))
    }
  },

  methods: {
    categoryOrderIndex(category) {
      let idx = Enums.SeWageResponseCategoryOrder.indexOf(category)
      return idx === -1 ? Number.MAX_SAFE_INTEGER : idx
    },
    categoryLabel(category) {
      return Enums.SeWageResponseCategoryTypeLabel[category] || category
    },
    formatDate(value) {
      if (!value) return ''
      return value.includes('-') ? toMMDDYYYYDateString(value) : value
    },
    rateDetail(item) {
      let parts = []
      if (item.hourlyRateOfPay !== null && item.hourlyRateOfPay !== undefined) {
        parts.push(`${this.$filters.toCurrency(item.hourlyRateOfPay, true)}/hr`)
      }
      if (item.hoursCount !== null && item.hoursCount !== undefined) {
        parts.push(`${item.hoursCount} hr`)
      }
      if (item.payPeriodAmount !== null && item.payPeriodAmount !== undefined) {
        parts.push(`${this.$filters.toCurrency(item.payPeriodAmount, true)} pay`)
      }
      return parts.join('   ')
    }
  }
});
</script>
<style scoped>
.se-wage-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;
}

.se-wage-table th {
  background-color: rgba(229,248,255,1.0);
  color: rgba(0,0,0,0.75);
  font-weight: 700;
  text-align: left;
  padding: 10px;
  border: 1px solid #E4E7ED;
}

.se-wage-employer-table td {
  background-color: #F5F7FA;
  padding: 6px 10px;
  border: 1px solid #E4E7ED;
  vertical-align: top;
}

.se-wage-employer-table td:nth-child(2),
.se-wage-employer-table td:nth-child(3) {
  text-align: right;
}

.se-wage-item-row td {
  font-size: 0.9rem;
  color: rgba(0,0,0,0.65);
  background-color: #FFFFFF;
}

.se-wage-item-row td:first-child {
  padding-left: 25px;
}

.se-wage-subheader-row td {
  background-color: rgba(229,248,255,1.0);
  font-weight: 700;
}

.se-wage-total-row td {
  background-color: rgba(229,248,255,1.0);
  font-weight: 700;
}
</style>

